import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IRefereeDTO } from "../../../../../api-services/football/admin/manage-football-referee-service";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { manageFootballRefereeService } from "../../../../../commons";

export interface IRefereeAddOption {
  refereeData: IRefereeDTO;
}

interface IRefereeAdd {
  refereeAddResponseStatus: StatusEnum;
}

const initialState: IRefereeAdd = {
  refereeAddResponseStatus: StatusEnum.Idle,
};

export const refereeAdd = createAsyncThunk("manage/refereeAdd", async (options: IRefereeAddOption, thunkAPI) => {
  try {
    const refereeAddResponse = await manageFootballRefereeService.addReferee(options.refereeData);
    return refereeAddResponse;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

const manageRefereeAddSlice = createSlice({
  name: "refereeAdd",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(refereeAdd.pending, (state) => {
        state.refereeAddResponseStatus = StatusEnum.Loading;
      })
      .addCase(refereeAdd.fulfilled, (state) => {
        state.refereeAddResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(refereeAdd.rejected, (state) => {
        state.refereeAddResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageRefereeAddSlice.reducer;
